/**
 * Enum for the type of external url
 */
export enum ExternalUrlType {
  INSTAGRAM = "INSTAGRAM",
  TWITTER = "TWITTER",
  PINTEREST = "PINTEREST",
  PINTEREST_LARGE = "PINTEREST_LARGE",
}
